<template>
  <div>
    <div v-if="fieldName && id && optionList" align="center">
      <el-button
        v-loading.fullscreen.lock="loading"
        type="primary"
        size="mini"
        @click="updateDataHandle('SUCCESS')"
      >
        ยืนยันการโอน
      </el-button>
    </div>
    <div v-else>
      <span>-</span>
    </div>
  </div>
</template>
<script>
import { baanRueJaiClient } from "@/dependencies"

export default {
  props: {
    fieldName: {
      type: String,
      require: true,
      default: undefined,
    },
    optionList: {
      type: Array,
      require: true,
      default: () => [],
    },
    id: {
      type: String,
      require: true,
      default: undefined,
    },
    defaultValue: {
      type: String,
      require: true,
      default: undefined,
    },
  },
  data() {
    return {
      dialogVisible: false,
      selectedUpdateValue: "",
      loading: false,
    }
  },
  created() {
    this.setDefaultData()
  },
  methods: {
    async updateDataHandle(value) {
      // Check change value
      if (value && this.defaultValue === value) return

      // eslint-disable-next-line no-alert
      if (window.confirm("ยืนยันการโอน?")) {
        // Open Loader
        this.loading = true

        // Request Payload
        const body = {
          fieldName: this.fieldName,
          value,
          id: this.id,
        }

        this.selectedUpdateValue = value

        try {
          // Request Update Status
          await baanRueJaiClient.admin.tokenx.updateEarnReportData(body)

          // Refresh Table
          this.$emit("onUpdateResult", true)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn("update-earn-report", error)
        } finally {
          // set default data
          this.setDefaultData()

          // Close Loader
          setTimeout(() => {
            this.loading = false
          }, 1000)
        }
      } else {
        this.setDefaultData()
      }
    },
    setDefaultData() {
      this.selectedUpdateValue = this.defaultValue
    },
  },
}
</script>
